import { zArr, zNum, zObj, zStr } from "./zodWrapper.js";
export const FishCompany = zObj({
    id: zNum(),
    name: zStr(),
});
export const FishLocation = zObj({
    id: zStr(),
    name: zStr(),
    companyId: zNum(),
});
export const BwFishInfo = zObj({
    companies: zArr(FishCompany),
    locations: zArr(FishLocation),
});
export const LocationsForCompany = zObj({
    locationIds: zArr(zStr()),
});
export const GetLocationsForCompanyArgs = zObj({
    companyId: zNum(),
});
//# sourceMappingURL=fishInfo.js.map